import { createBrowserHistory } from 'history'

// export default createBrowserHistory({

// })

export const history = createBrowserHistory();